export interface IStaffImportResult {
  personalEmail: string;
  success: boolean;
  errors?: Record<string, Record<string, true>>;
}